export enum IconSizes {
    Small = "-small",
    Base = "-base",
    Large = "-large",
    Medium = "-medium",
    XLarge = "-xlarge",
}
